import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apacheAirflow = defineConnector({
  identifier: "apacheAirflow",
  name: "Apache Airflow",
  tagLine: "Workflow orchestration platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://(?:[^/]*\\.astronomer\\.io/.*|[^/]*\\.composer\\.cloud\\.google\\.com/.*)",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your Airflow instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "airflow.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the username and password for an Airflow user with API access. See the [API docs](https://airflow.apache.org/docs/apache-airflow/stable/security/api.html) for details.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/dags?limit=1`,
  },
});
